import type { Node as ProseMirrorNode } from '@tiptap/pm/model';

/**
 * Extract plain text from a tiptap editor, converting hard breaks to `\n`
 * and separating paragraphs with `\n`. `editor.getText()` ignores hard
 * breaks because they are inline nodes, so we walk the document manually.
 */
export function getEditorText(doc: ProseMirrorNode): string {
  const blocks: string[] = [];
  // ProseMirror nodes are not iterable — must use .forEach()
  // eslint-disable-next-line unicorn/no-array-for-each
  doc.forEach((block) => {
    const parts: string[] = [];
    // eslint-disable-next-line unicorn/no-array-for-each
    block.forEach((child) => {
      if (child.type.name === 'hardBreak') {
        parts.push('\n');
      } else if (child.isText === true && typeof child.text === 'string') {
        parts.push(child.text);
      }
    });
    blocks.push(parts.join(''));
  });
  return blocks.join('\n');
}

/**
 * Build a tiptap-compatible JSON document from a plain text string.
 * Newlines become hardBreak nodes within a single paragraph so the text
 * round-trips correctly through `getEditorText`.
 */
export function buildDocFromText(input: string): Record<string, unknown> {
  const parts = input.split('\n');
  const content: Array<{ type: string; text?: string }> = [];
  for (let index = 0; index < parts.length; index++) {
    if (index > 0) {
      content.push({ type: 'hardBreak' });
    }
    if (parts[index].length > 0) {
      content.push({ type: 'text', text: parts[index] });
    }
  }
  return {
    type: 'doc',
    content: [{ type: 'paragraph', content: content.length > 0 ? content : undefined }],
  };
}
